module.exports = __webpack_public_path__ + "static/media/villasofia-parkkipaikat-small.6c9d33df.png";